import { useMutation } from 'react-query';
import { ReportAreasParams, ReportNcmParams } from './Report.types';
import { generateAreasReport, generateNcmReport } from './Report.service';
import { useServiceError } from '@/hooks';
import { notification } from 'antd';

export function useGenerateAreasReport() {
  const mutation = useMutation((obj: ReportAreasParams) =>
    generateAreasReport(obj),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useGenerateNcmReport() {
  const mutation = useMutation(
    (obj: ReportNcmParams) => generateNcmReport(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Relatório de Ncm gerado com sucesso',
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
